<script>
import CustomersApi from "@/services/customers-api";
import CountriesApi from "@/services/countries-api";
import ReportingApi from "@/services/reporting-api";
import BarChart from "./BarChart";
import i18n from "@/i18n";

export default {
    components: {    BarChart,
  },
    props: {
      firstDay:{
          type:String,
          default:null
      },
      lastDay:{
          type:String,
          default:null
      }
    },

    computed: {
        role() {
          return this.$cookies.get('userr');
        },
    },

    mounted(){
        
        if(this.role == 1){
          this.getCustomers()
          this.getCountries();
        }
        this.getOrdersStatus()    
    } ,
    data(){
        return{
            start:this.firstDay,
            end:this.lastDay,
            customersList:[],
            selectedCustomer:null,
            selectedCountry:null,
            selectedCity:null,
            citiesList:[],
            countriesList:[],
            
            loading_sources:false,
            labels:[],
            data:[],
            colors:[],
            componentKey: 0,
        };
    },
      methods:{
        getCustomers(){
        CustomersApi.getCustomers(this.selectedCountry==null ? null : this.selectedCountry.id,this.selectedCity==null ? null : this.selectedCity.id).then(
            response => {
            this.customersList=response;
            }
        )
        },
        getCountries(){
        CountriesApi.getCountries().then(
            result => {
                this.countriesList = result
            })
        },
        getCities(){
        CountriesApi.getCities(this.selectedCountry ? this.selectedCountry.id : null).then(
            result => {
                this.citiesList = result
            })
        },

        statusToLabel(status) {
          switch(status) {
            case 1: return i18n.t('reporting.customer.orderState.new');
            case 2: return i18n.t('reporting.customer.orderState.confirmed');
            case 3: return i18n.t('reporting.customer.orderState.delivered');
            case 4: return i18n.t('reporting.customer.orderState.canceled');
            default: return '';
          }
        },

        statusToColor(status) {
          switch(status) {
            case 1: return '#f46a6a';
            case 2: return '#f1b44c';
            case 3: return '#34c38f'
            case 4: return '#74788d';
            default: return 'secondary';
          }
        },

      getOrdersStatus(){
        ReportingApi.getOrdersStatus(this.start,this.end,this.selectedCountry==null ? null : this.selectedCountry.id,this.selectedCity==null ? null : this.selectedCity.id,this.selectedCustomer==null ? null : this.selectedCustomer.id).then(

          (result)=>{
            if(result){
              this.loading_sources=false
              this.componentKey += 1;
              this.labels=[]
              this.colors=[]
              this.data=[]
              for(const i in result){
                this.labels.push(this.statusToLabel(result[i].status))
                this.data.push(result[i].count)
                this.colors.push(this.statusToColor(result[i].status))
              }
              this.loading_sources=true
            }
          }
        )
      },
    },
    watch: {
        end: function(){
          if((this.end  && this.start) || (!this.end  && !this.start) ){
            this.getOrdersStatus()
          }
          
        },
        start: function(){
          if((this.end && this.start) || (!this.end  && !this.start)  ){
            this.getOrdersStatus()

          }
        },
        selectedCountry: function(){
          this.getOrdersStatus()
          this.getCustomers()
          if(this.selectedCountry != null){
            this.getCities()
          }else{
            this.selectedCity=null
            this.citiesList=[]
          }
        },
        selectedCity: function(){
            this.getCustomers()
            if(this.selectedCountry!=null){
              this.getOrdersStatus()
            }
        },
        selectedCustomer: function(){
          this.getOrdersStatus()

        },

        role: function(){
            if(this.role == 1){
            this.getCustomers()
            this.getCountries();
        }

        },

        
    }
  
}
</script>
<template>
    <div class="clearfix m-4">
        <div class="row">
            <div class="col-11">
                <h4 class="card-title mb-2 font-size-18 font-weight-bold text-dark">{{$t('reporting.customer.orderState.title')}}</h4>
            </div>
        </div>
        <div v-if="role==1" class="row mt-3">
            <!-- <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 pr-lg-2">
                <b-form-group label="" label-for="">
                    <v-select :options="countriesList" :placeholder="$t('lists.countries.label')" label="name" v-model="selectedCountry">
                    <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                    </v-select>
                </b-form-group>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 pr-lg-2">
                <b-form-group label="" label-for="">
                    <v-select :options="citiesList" :placeholder="$t('lists.cities.label')" label="name" v-model="selectedCity">
                    <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                    </v-select>
                </b-form-group>
            </div> -->
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <b-form-group label="" label-for="">
                    <v-select :options="customersList" :placeholder="$t('lists.customers.label')" label="fullCompanyName" v-model="selectedCustomer">
                    <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                    </v-select>
                </b-form-group>
            </div>
        </div>
        <div class="row text-center" :class="role==0 ? 'pt-4' : ''" >
          <div class="col-xl-6 col-lg-6 col-md-12 col-cm-12 col-xs-12 pr-lg-2">
            <b-form-group  label-for="">
              <b-form-datepicker
                v-model="start"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright
                hide-header
              ></b-form-datepicker>
            </b-form-group>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12 col-cm-12 col-xs-12">
            <b-form-group  label-for="">
              <b-form-datepicker
                v-model="end"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright                         
                hide-header
              ></b-form-datepicker>
            </b-form-group>
          </div>
      </div>
  
      <div class="row text-center">
        <div class="col-sm-4">
          <h5 class="mb-0"></h5>
          <p class="text-muted"></p>
        </div>
        <div class="col-sm-4">

        </div>
        <div class="col-sm-4">
          <h5 class="mb-0"></h5>
          <p class="text-muted"></p>
        </div>
      </div>

      <BarChart v-if="loading_sources" :height="300" :labels.sync="this.labels" :data.sync="this.data" :colors.sync="this.colors" :key="componentKey" />

    </div>
</template>